import * as React from "react";
import { copyHtmlToClipboard } from "@/helpers/clipboard";
import { CopyActionButton } from "@/components/chat/actions/CopyActionButton";
import { useCopyAction } from "@/hooks/useCopyAction";

interface Props {
  children: React.ReactNode;
  hideActions?: boolean;
}

const tableToPlainText = (table: HTMLTableElement): string =>
  Array.from(table.rows)
    .map(row =>
      Array.from(row.cells)
        .map(cell => cell.innerText.trim())
        .join("\t"),
    )
    .join("\n");

export const CopyableTable = ({ children, hideActions }: Props) => {
  const tableRef = React.useRef<HTMLTableElement>(null);
  const { copied, executeCopy } = useCopyAction();

  const handleCopy = () =>
    executeCopy(async () => {
      if (!tableRef.current) return;
      await copyHtmlToClipboard(tableRef.current.outerHTML, tableToPlainText(tableRef.current));
    });

  return (
    <div className="group/table relative my-4 w-full min-w-0 max-w-full overflow-x-auto overflow-y-hidden rounded-lg border border-desert-sand-300 bg-white/60">
      <table ref={tableRef} className="w-max min-w-full whitespace-nowrap text-sm">
        {children}
      </table>
      {!hideActions && (
        <div className="absolute bottom-2 right-2 opacity-30 transition-opacity group-focus-within/table:opacity-100 group-hover/table:opacity-100">
          <CopyActionButton copied={copied} onCopy={handleCopy} />
        </div>
      )}
    </div>
  );
};
